export const locations = [
    {
        "state_name": "Andhra Pradesh",
        "districts": [
            { "district_name": "Anantapur" },
            { "district_name": "Chittoor" },
            { "district_name": "East Godavari" },
            { "district_name": "Guntur" },
            { "district_name": "Kadapa" },
            { "district_name": "Krishna" },
            { "district_name": "Kurnool" },
            { "district_name": "Nandyal" },
            { "district_name": "Nellore" },
            { "district_name": "Palnadu" },
            { "district_name": "Prakasam" },
            { "district_name": "Srikakulam" },
            { "district_name": "Tirupati" },
            { "district_name": "Visakhapatnam" },
            { "district_name": "Vizianagaram" },
            { "district_name": "West Godavari" }
        ]
    },
    {
        "state_name": "Arunachal Pradesh",
        "districts": [
            { "district_name": "Anjaw" },
            { "district_name": "Changlang" },
            { "district_name": "Dibang Valley" },
            { "district_name": "East Kameng" },
            { "district_name": "East Siang" },
            { "district_name": "Kamle" },
            { "district_name": "Kra Daadi" },
            { "district_name": "Kurung Kumey" },
            { "district_name": "Lepa Rada" },
            { "district_name": "Lohit" },
            { "district_name": "Longding" },
            { "district_name": "Lower Dibang Valley" },
            { "district_name": "Lower Siang" },
            { "district_name": "Lower Subansiri" },
            { "district_name": "Namsai" },
            { "district_name": "Pakke Kessang" },
            { "district_name": "Papum Pare" },
            { "district_name": "Shi Yomi" },
            { "district_name": "Siang" },
            { "district_name": "Tawang" },
            { "district_name": "Tirap" },
            { "district_name": "Upper Siang" },
            { "district_name": "Upper Subansiri" },
            { "district_name": "West Kameng" },
            { "district_name": "West Siang" }
        ]
    },
    {
        "state_name": "Assam",
        "districts": [
            { "district_name": "Bajali" },
            { "district_name": "Baksa" },
            { "district_name": "Barpeta" },
            { "district_name": "Biswanath" },
            { "district_name": "Bongaigaon" },
            { "district_name": "Cachar" },
            { "district_name": "Charaideo" },
            { "district_name": "Chirang" },
            { "district_name": "Darrang" },
            { "district_name": "Dhemaji" },
            { "district_name": "Dhubri" },
            { "district_name": "Dibrugarh" },
            { "district_name": "Dima Hasao" },
            { "district_name": "Goalpara" },
            { "district_name": "Golaghat" },
            { "district_name": "Hailakandi" },
            { "district_name": "Hojai" },
            { "district_name": "Jorhat" },
            { "district_name": "Kamrup Metropolitan" },
            { "district_name": "Kamrup Rural" },
            { "district_name": "Karbi Anglong" },
            { "district_name": "Karimganj" },
            { "district_name": "Kokrajhar" },
            { "district_name": "Lakhimpur" },
            { "district_name": "Majuli" },
            { "district_name": "Morigaon" },
            { "district_name": "Nagaon" },
            { "district_name": "Nalbari" },
            { "district_name": "Sivasagar" },
            { "district_name": "Sonitpur" },
            { "district_name": "South Salmara-Mankachar" },
            { "district_name": "Tamulpur" },
            { "district_name": "Tinsukia" },
            { "district_name": "Udalguri" },
            { "district_name": "West Karbi Anglong" }
        ]
    },
    {
        "state_name": "Bihar",
        "districts": [
            { "district_name": "Araria" },
            { "district_name": "Arwal" },
            { "district_name": "Aurangabad" },
            { "district_name": "Banka" },
            { "district_name": "Begusarai" },
            { "district_name": "Bhagalpur" },
            { "district_name": "Bhojpur" },
            { "district_name": "Buxar" },
            { "district_name": "Darbhanga" },
            { "district_name": "East Champaran" },
            { "district_name": "Gaya" },
            { "district_name": "Gopalganj" },
            { "district_name": "Jamui" },
            { "district_name": "Jehanabad" },
            { "district_name": "Kaimur" },
            { "district_name": "Katihar" },
            { "district_name": "Khagaria" },
            { "district_name": "Kishanganj" },
            { "district_name": "Lakhisarai" },
            { "district_name": "Madhepura" },
            { "district_name": "Madhubani" },
            { "district_name": "Munger" },
            { "district_name": "Muzaffarpur" },
            { "district_name": "Nalanda" },
            { "district_name": "Nawada" },
            { "district_name": "Patna" },
            { "district_name": "Purnia" },
            { "district_name": "Rohtas" },
            { "district_name": "Saharsa" },
            { "district_name": "Samastipur" },
            { "district_name": "Saran" },
            { "district_name": "Sheikhpura" },
            { "district_name": "Sheohar" },
            { "district_name": "Sitamarhi" },
            { "district_name": "Siwan" },
            { "district_name": "Supaul" },
            { "district_name": "Vaishali" },
            { "district_name": "West Champaran" }
        ]
    },
    {
        "state_name": "Chhattisgarh",
        "districts": [
            { "district_name": "Balod" },
            { "district_name": "Baloda Bazar" },
            { "district_name": "Balrampur" },
            { "district_name": "Bastar" },
            { "district_name": "Bemetara" },
            { "district_name": "Bijapur" },
            { "district_name": "Bilaspur" },
            { "district_name": "Dantewada" },
            { "district_name": "Dhamtari" },
            { "district_name": "Durg" },
            { "district_name": "Gariaband" },
            { "district_name": "Gaurela-Pendra-Marwahi" },
            { "district_name": "Janjgir-Champa" },
            { "district_name": "Jashpur" },
            { "district_name": "Kabirdham" },
            { "district_name": "Kanker" },
            { "district_name": "Kondagaon" },
            { "district_name": "Korba" },
            { "district_name": "Koriya" },
            { "district_name": "Mahasamund" },
            { "district_name": "Mungeli" },
            { "district_name": "Narayanpur" },
            { "district_name": "Raigarh" },
            { "district_name": "Raipur" },
            { "district_name": "Rajnandgaon" },
            { "district_name": "Sukma" },
            { "district_name": "Surajpur" },
            { "district_name": "Surguja" }
        ]
    },
    {
        "state_name": "Goa",
        "districts": [
            { "district_name": "North Goa" },
            { "district_name": "South Goa" }
        ]
    },
    {
        "state_name": "Gujarat",
        "districts": [
            { "district_name": "Ahmedabad" },
            { "district_name": "Amreli" },
            { "district_name": "Anand" },
            { "district_name": "Aravalli" },
            { "district_name": "Banaskantha" },
            { "district_name": "Bharuch" },
            { "district_name": "Bhavnagar" },
            { "district_name": "Botad" },
            { "district_name": "Chhota Udaipur" },
            { "district_name": "Dahod" },
            { "district_name": "Dang" },
            { "district_name": "Devbhoomi Dwarka" },
            { "district_name": "Gandhinagar" },
            { "district_name": "Gir Somnath" },
            { "district_name": "Jamnagar" },
            { "district_name": "Junagadh" },
            { "district_name": "Kheda" },
            { "district_name": "Kutch" },
            { "district_name": "Mahisagar" },
            { "district_name": "Mehsana" },
            { "district_name": "Morbi" },
            { "district_name": "Narmada" },
            { "district_name": "Navsari" },
            { "district_name": "Panchmahal" },
            { "district_name": "Patan" },
            { "district_name": "Porbandar" },
            { "district_name": "Rajkot" },
            { "district_name": "Sabarkantha" },
            { "district_name": "Surat" },
            { "district_name": "Surendranagar" },
            { "district_name": "Tapi" },
            { "district_name": "Vadodara" },
            { "district_name": "Valsad" }
        ]
    },
    {
        "state_name": "Haryana",
        "districts": [
            { "district_name": "Ambala" },
            { "district_name": "Bhiwani" },
            { "district_name": "Charkhi Dadri" },
            { "district_name": "Faridabad" },
            { "district_name": "Fatehabad" },
            { "district_name": "Gurugram" },
            { "district_name": "Hisar" },
            { "district_name": "Jhajjar" },
            { "district_name": "Jind" },
            { "district_name": "Kaithal" },
            { "district_name": "Karnal" },
            { "district_name": "Kurukshetra" },
            { "district_name": "Mahendragarh" },
            { "district_name": "Nuh" },
            { "district_name": "Palwal" },
            { "district_name": "Panchkula" },
            { "district_name": "Panipat" },
            { "district_name": "Rewari" },
            { "district_name": "Rohtak" },
            { "district_name": "Sirsa" },
            { "district_name": "Sonipat" },
            { "district_name": "Yamunanagar" }
        ]
    },
    {
        "state_name": "Himachal Pradesh",
        "districts": [
            { "district_name": "Bilaspur" },
            { "district_name": "Chamba" },
            { "district_name": "Hamirpur" },
            { "district_name": "Kangra" },
            { "district_name": "Kinnaur" },
            { "district_name": "Kullu" },
            { "district_name": "Lahaul and Spiti" },
            { "district_name": "Mandi" },
            { "district_name": "Shimla" },
            { "district_name": "Sirmaur" },
            { "district_name": "Solan" },
            { "district_name": "Una" }
        ]
    },
    {
        "state_name": "Jharkhand",
        "districts": [
            { "district_name": "Bokaro" },
            { "district_name": "Chatra" },
            { "district_name": "Deoghar" },
            { "district_name": "Dhanbad" },
            { "district_name": "Dumka" },
            { "district_name": "East Singhbhum" },
            { "district_name": "Garhwa" },
            { "district_name": "Giridih" },
            { "district_name": "Godda" },
            { "district_name": "Gumla" },
            { "district_name": "Hazaribagh" },
            { "district_name": "Jamtara" },
            { "district_name": "Khunti" },
            { "district_name": "Koderma" },
            { "district_name": "Latehar" },
            { "district_name": "Lohardaga" },
            { "district_name": "Pakur" },
            { "district_name": "Palamu" },
            { "district_name": "Ramgarh" },
            { "district_name": "Ranchi" },
            { "district_name": "Sahebganj" },
            { "district_name": "Seraikela-Kharsawan" },
            { "district_name": "Simdega" },
            { "district_name": "West Singhbhum" }
        ]
    },
    {
        "state_name": "Karnataka",
        "districts": [
            { "district_name": "Bagalkot" },
            { "district_name": "Ballari" },
            { "district_name": "Belagavi" },
            { "district_name": "Bengaluru Rural" },
            { "district_name": "Bengaluru Urban" },
            { "district_name": "Bidar" },
            { "district_name": "Chamarajanagar" },
            { "district_name": "Chikballapur" },
            { "district_name": "Chikkamagaluru" },
            { "district_name": "Chitradurga" },
            { "district_name": "Dakshina Kannada" },
            { "district_name": "Davanagere" },
            { "district_name": "Dharwad" },
            { "district_name": "Gadag" },
            { "district_name": "Hassan" },
            { "district_name": "Haveri" },
            { "district_name": "Kalaburagi" },
            { "district_name": "Kodagu" },
            { "district_name": "Kolar" },
            { "district_name": "Koppal" },
            { "district_name": "Mandya" },
            { "district_name": "Mysuru" },
            { "district_name": "Raichur" },
            { "district_name": "Ramanagara" },
            { "district_name": "Shivamogga" },
            { "district_name": "Tumakuru" },
            { "district_name": "Udupi" },
            { "district_name": "Uttara Kannada" },
            { "district_name": "Vijayapura" },
            { "district_name": "Yadgir" }
        ]
    },
    {
        "state_name": "Kerala",
        "districts": [
            { "district_name": "Alappuzha" },
            { "district_name": "Ernakulam" },
            { "district_name": "Idukki" },
            { "district_name": "Kannur" },
            { "district_name": "Kasaragod" },
            { "district_name": "Kollam" },
            { "district_name": "Kottayam" },
            { "district_name": "Kozhikode" },
            { "district_name": "Malappuram" },
            { "district_name": "Palakkad" },
            { "district_name": "Pathanamthitta" },
            { "district_name": "Thiruvananthapuram" },
            { "district_name": "Thrissur" },
            { "district_name": "Wayanad" }
        ]
    },
    {
        "state_name": "Madhya Pradesh",
        "districts": [
            { "district_name": "Agar Malwa" },
            { "district_name": "Alirajpur" },
            { "district_name": "Anuppur" },
            { "district_name": "Ashoknagar" },
            { "district_name": "Balaghat" },
            { "district_name": "Barwani" },
            { "district_name": "Betul" },
            { "district_name": "Bhind" },
            { "district_name": "Bhopal" },
            { "district_name": "Burhanpur" },
            { "district_name": "Chhatarpur" },
            { "district_name": "Chhindwara" },
            { "district_name": "Damoh" },
            { "district_name": "Datia" },
            { "district_name": "Dewas" },
            { "district_name": "Dhar" },
            { "district_name": "Dindori" },
            { "district_name": "Guna" },
            { "district_name": "Gwalior" },
            { "district_name": "Harda" },
            { "district_name": "Hoshangabad" },
            { "district_name": "Indore" },
            { "district_name": "Jabalpur" },
            { "district_name": "Jhabua" },
            { "district_name": "Katni" },
            { "district_name": "Khandwa" },
            { "district_name": "Khargone" },
            { "district_name": "Mandla" },
            { "district_name": "Mandsaur" },
            { "district_name": "Morena" },
            { "district_name": "Narsinghpur" },
            { "district_name": "Neemuch" },
            { "district_name": "Niwari" },
            { "district_name": "Panna" },
            { "district_name": "Raisen" },
            { "district_name": "Rajgarh" },
            { "district_name": "Ratlam" },
            { "district_name": "Rewa" },
            { "district_name": "Sagar" },
            { "district_name": "Satna" },
            { "district_name": "Sehore" },
            { "district_name": "Seoni" },
            { "district_name": "Shahdol" },
            { "district_name": "Shajapur" },
            { "district_name": "Sheopur" },
            { "district_name": "Shivpuri" },
            { "district_name": "Sidhi" },
            { "district_name": "Singrauli" },
            { "district_name": "Tikamgarh" },
            { "district_name": "Ujjain" },
            { "district_name": "Umaria" },
            { "district_name": "Vidisha" }
        ]
    },
    {
        "state_name": "Maharashtra",
        "districts": [
            { "district_name": "Ahmednagar" },
            { "district_name": "Akola" },
            { "district_name": "Amravati" },
            { "district_name": "Aurangabad" },
            { "district_name": "Beed" },
            { "district_name": "Bhandara" },
            { "district_name": "Buldhana" },
            { "district_name": "Chandrapur" },
            { "district_name": "Dhule" },
            { "district_name": "Gadchiroli" },
            { "district_name": "Gondia" },
            { "district_name": "Hingoli" },
            { "district_name": "Jalgaon" },
            { "district_name": "Jalna" },
            { "district_name": "Kolhapur" },
            { "district_name": "Latur" },
            { "district_name": "Mumbai City" },
            { "district_name": "Mumbai Suburban" },
            { "district_name": "Nagpur" },
            { "district_name": "Nanded" },
            { "district_name": "Nandurbar" },
            { "district_name": "Nashik" },
            { "district_name": "Osmanabad" },
            { "district_name": "Palghar" },
            { "district_name": "Parbhani" },
            { "district_name": "Pune" },
            { "district_name": "Raigad" },
            { "district_name": "Ratnagiri" },
            { "district_name": "Sangli" },
            { "district_name": "Satara" },
            { "district_name": "Sindhudurg" },
            { "district_name": "Solapur" },
            { "district_name": "Thane" },
            { "district_name": "Wardha" },
            { "district_name": "Washim" },
            { "district_name": "Yavatmal" }
        ]
    },
    {
        "state_name": "Manipur",
        "districts": [
            { "district_name": "Bishnupur" },
            { "district_name": "Chandel" },
            { "district_name": "Churachandpur" },
            { "district_name": "Imphal East" },
            { "district_name": "Imphal West" },
            { "district_name": "Jiribam" },
            { "district_name": "Kakching" },
            { "district_name": "Kamjong" },
            { "district_name": "Kangpokpi" },
            { "district_name": "Noney" },
            { "district_name": "Pherzawl" },
            { "district_name": "Senapati" },
            { "district_name": "Tamenglong" },
            { "district_name": "Tengnoupal" },
            { "district_name": "Thoubal" },
            { "district_name": "Ukhrul" }
        ]
    },
    {
        "state_name": "Meghalaya",
        "districts": [
            { "district_name": "East Garo Hills" },
            { "district_name": "East Jaintia Hills" },
            { "district_name": "East Khasi Hills" },
            { "district_name": "North Garo Hills" },
            { "district_name": "Ri Bhoi" },
            { "district_name": "South Garo Hills" },
            { "district_name": "South West Garo Hills" },
            { "district_name": "South West Khasi Hills" },
            { "district_name": "West Garo Hills" },
            { "district_name": "West Jaintia Hills" },
            { "district_name": "West Khasi Hills" }
        ]
    },
    {
        "state_name": "Mizoram",
        "districts": [
            { "district_name": "Aizawl" },
            { "district_name": "Champhai" },
            { "district_name": "Hnahthial" },
            { "district_name": "Khawzawl" },
            { "district_name": "Kolasib" },
            { "district_name": "Lawngtlai" },
            { "district_name": "Lunglei" },
            { "district_name": "Mamit" },
            { "district_name": "Saiha" },
            { "district_name": "Saitual" },
            { "district_name": "Serchhip" }
        ]
    },
    {
        "state_name": "Nagaland",
        "districts": [
            { "district_name": "Chümoukedima" },
            { "district_name": "Dimapur" },
            { "district_name": "Kiphire" },
            { "district_name": "Kohima" },
            { "district_name": "Longleng" },
            { "district_name": "Mokokchung" },
            { "district_name": "Mon" },
            { "district_name": "Niuland" },
            { "district_name": "Noklak" },
            { "district_name": "Peren" },
            { "district_name": "Phek" },
            { "district_name": "Shamator" },
            { "district_name": "Tuensang" },
            { "district_name": "Wokha" },
            { "district_name": "Zunheboto" }
        ]
    },
    {
        "state_name": "Odisha",
        "districts": [
            { "district_name": "Angul" },
            { "district_name": "Balangir" },
            { "district_name": "Balasore" },
            { "district_name": "Bargarh" },
            { "district_name": "Bhadrak" },
            { "district_name": "Boudh" },
            { "district_name": "Cuttack" },
            { "district_name": "Deogarh" },
            { "district_name": "Dhenkanal" },
            { "district_name": "Gajapati" },
            { "district_name": "Ganjam" },
            { "district_name": "Jagatsinghpur" },
            { "district_name": "Jajpur" },
            { "district_name": "Jharsuguda" },
            { "district_name": "Kalahandi" },
            { "district_name": "Kandhamal" },
            { "district_name": "Kendrapara" },
            { "district_name": "Kendujhar" },
            { "district_name": "Khordha" },
            { "district_name": "Koraput" },
            { "district_name": "Malkangiri" },
            { "district_name": "Mayurbhanj" },
            { "district_name": "Nabarangpur" },
            { "district_name": "Nayagarh" },
            { "district_name": "Nuapada" },
            { "district_name": "Puri" },
            { "district_name": "Rayagada" },
            { "district_name": "Sambalpur" },
            { "district_name": "Subarnapur" },
            { "district_name": "Sundargarh" }
        ]
    },
    {
        "state_name": "Punjab",
        "districts": [
            { "district_name": "Amritsar" },
            { "district_name": "Barnala" },
            { "district_name": "Bathinda" },
            { "district_name": "Faridkot" },
            { "district_name": "Fatehgarh Sahib" },
            { "district_name": "Fazilka" },
            { "district_name": "Ferozepur" },
            { "district_name": "Gurdaspur" },
            { "district_name": "Hoshiarpur" },
            { "district_name": "Jalandhar" },
            { "district_name": "Kapurthala" },
            { "district_name": "Ludhiana" },
            { "district_name": "Malerkotla" },
            { "district_name": "Mansa" },
            { "district_name": "Moga" },
            { "district_name": "Mohali" },
            { "district_name": "Muktsar" },
            { "district_name": "Pathankot" },
            { "district_name": "Patiala" },
            { "district_name": "Rupnagar" },
            { "district_name": "Sangrur" },
            { "district_name": "Shaheed Bhagat Singh Nagar" },
            { "district_name": "Tarn Taran" }
        ]
    },
    {
        "state_name": "Rajasthan",
        "districts": [
            { "district_name": "Ajmer" },
            { "district_name": "Alwar" },
            { "district_name": "Banswara" },
            { "district_name": "Baran" },
            { "district_name": "Barmer" },
            { "district_name": "Bharatpur" },
            { "district_name": "Bhilwara" },
            { "district_name": "Bikaner" },
            { "district_name": "Bundi" },
            { "district_name": "Chittorgarh" },
            { "district_name": "Churu" },
            { "district_name": "Dausa" },
            { "district_name": "Dholpur" },
            { "district_name": "Dungarpur" },
            { "district_name": "Hanumangarh" },
            { "district_name": "Jaipur" },
            { "district_name": "Jaisalmer" },
            { "district_name": "Jalore" },
            { "district_name": "Jhalawar" },
            { "district_name": "Jhunjhunu" },
            { "district_name": "Jodhpur" },
            { "district_name": "Karauli" },
            { "district_name": "Kota" },
            { "district_name": "Nagaur" },
            { "district_name": "Pali" },
            { "district_name": "Pratapgarh" },
            { "district_name": "Rajsamand" },
            { "district_name": "Sawai Madhopur" },
            { "district_name": "Sikar" },
            { "district_name": "Sirohi" },
            { "district_name": "Sri Ganganagar" },
            { "district_name": "Tonk" },
            { "district_name": "Udaipur" }
        ]
    },
    {
        "state_name": "Sikkim",
        "districts": [
            { "district_name": "East Sikkim" },
            { "district_name": "North Sikkim" },
            { "district_name": "South Sikkim" },
            { "district_name": "West Sikkim" }
        ]
    },
    {
        "state_name": "Tamil Nadu",
        "districts": [
            { "district_name": "Ariyalur" },
            { "district_name": "Chengalpattu" },
            { "district_name": "Chennai" },
            { "district_name": "Coimbatore" },
            { "district_name": "Cuddalore" },
            { "district_name": "Dharmapuri" },
            { "district_name": "Dindigul" },
            { "district_name": "Erode" },
            { "district_name": "Kallakurichi" },
            { "district_name": "Kanchipuram" },
            { "district_name": "Kanyakumari" },
            { "district_name": "Karur" },
            { "district_name": "Krishnagiri" },
            { "district_name": "Madurai" },
            { "district_name": "Mayiladuthurai" },
            { "district_name": "Nagapattinam" },
            { "district_name": "Namakkal" },
            { "district_name": "Nilgiris" },
            { "district_name": "Perambalur" },
            { "district_name": "Pudukkottai" },
            { "district_name": "Ramanathapuram" },
            { "district_name": "Ranipet" },
            { "district_name": "Salem" },
            { "district_name": "Sivaganga" },
            { "district_name": "Tenkasi" },
            { "district_name": "Thanjavur" },
            { "district_name": "Theni" },
            { "district_name": "Thoothukudi" },
            { "district_name": "Tiruchirappalli" },
            { "district_name": "Tirunelveli" },
            { "district_name": "Tirupathur" },
            { "district_name": "Tiruppur" },
            { "district_name": "Tiruvallur" },
            { "district_name": "Tiruvannamalai" },
            { "district_name": "Tiruvarur" },
            { "district_name": "Vellore" },
            { "district_name": "Viluppuram" },
            { "district_name": "Virudhunagar" }
        ]
    },
    {
        "state_name": "Telangana",
        "districts": [
            { "district_name": "Adilabad" },
            { "district_name": "Bhadradri Kothagudem" },
            { "district_name": "Hanamkonda" },
            { "district_name": "Hyderabad" },
            { "district_name": "Jagtial" },
            { "district_name": "Jangaon" },
            { "district_name": "Jayashankar Bhupalpally" },
            { "district_name": "Jogulamba Gadwal" },
            { "district_name": "Kamareddy" },
            { "district_name": "Karimnagar" },
            { "district_name": "Khammam" },
            { "district_name": "Kumuram Bheem Asifabad" },
            { "district_name": "Mahabubabad" },
            { "district_name": "Mahabubnagar" },
            { "district_name": "Mancherial" },
            { "district_name": "Medak" },
            { "district_name": "Medchal-Malkajgiri" },
            { "district_name": "Mulugu" },
            { "district_name": "Nagarkurnool" },
            { "district_name": "Nalgonda" },
            { "district_name": "Narayanpet" },
            { "district_name": "Nirmal" },
            { "district_name": "Nizamabad" },
            { "district_name": "Peddapalli" },
            { "district_name": "Rajanna Sircilla" },
            { "district_name": "Rangareddy" },
            { "district_name": "Sangareddy" },
            { "district_name": "Siddipet" },
            { "district_name": "Suryapet" },
            { "district_name": "Vikarabad" },
            { "district_name": "Wanaparthy" },
            { "district_name": "Warangal" },
            { "district_name": "Yadadri Bhuvanagiri" }
        ]
    },
    {
        "state_name": "Tripura",
        "districts": [
            { "district_name": "Dhalai" },
            { "district_name": "Gomati" },
            { "district_name": "Khowai" },
            { "district_name": "North Tripura" },
            { "district_name": "Sepahijala" },
            { "district_name": "South Tripura" },
            { "district_name": "Unakoti" },
            { "district_name": "West Tripura" }
        ]
    },
    {
        "state_name": "Uttar Pradesh",
        "districts": [
            { "district_name": "Agra" },
            { "district_name": "Aligarh" },
            { "district_name": "Ambedkar Nagar" },
            { "district_name": "Amethi" },
            { "district_name": "Amroha" },
            { "district_name": "Auraiya" },
            { "district_name": "Ayodhya" },
            { "district_name": "Azamgarh" },
            { "district_name": "Baghpat" },
            { "district_name": "Bahraich" },
            { "district_name": "Ballia" },
            { "district_name": "Balrampur" },
            { "district_name": "Banda" },
            { "district_name": "Barabanki" },
            { "district_name": "Bareilly" },
            { "district_name": "Basti" },
            { "district_name": "Bhadohi" },
            { "district_name": "Bijnor" },
            { "district_name": "Budaun" },
            { "district_name": "Bulandshahr" },
            { "district_name": "Chandauli" },
            { "district_name": "Chitrakoot" },
            { "district_name": "Deoria" },
            { "district_name": "Etah" },
            { "district_name": "Etawah" },
            { "district_name": "Farrukhabad" },
            { "district_name": "Fatehpur" },
            { "district_name": "Firozabad" },
            { "district_name": "Gautam Buddha Nagar" },
            { "district_name": "Ghaziabad" },
            { "district_name": "Ghazipur" },
            { "district_name": "Gonda" },
            { "district_name": "Gorakhpur" },
            { "district_name": "Hamirpur" },
            { "district_name": "Hapur" },
            { "district_name": "Hardoi" },
            { "district_name": "Hathras" },
            { "district_name": "Jalaun" },
            { "district_name": "Jaunpur" },
            { "district_name": "Jhansi" },
            { "district_name": "Kannauj" },
            { "district_name": "Kanpur Dehat" },
            { "district_name": "Kanpur Nagar" },
            { "district_name": "Kasganj" },
            { "district_name": "Kaushambi" },
            { "district_name": "Kushinagar" },
            { "district_name": "Lakhimpur Kheri" },
            { "district_name": "Lalitpur" },
            { "district_name": "Lucknow" },
            { "district_name": "Maharajganj" },
            { "district_name": "Mahoba" },
            { "district_name": "Mainpuri" },
            { "district_name": "Mathura" },
            { "district_name": "Mau" },
            { "district_name": "Meerut" },
            { "district_name": "Mirzapur" },
            { "district_name": "Moradabad" },
            { "district_name": "Muzaffarnagar" },
            { "district_name": "Pilibhit" },
            { "district_name": "Pratapgarh" },
            { "district_name": "Prayagraj" },
            { "district_name": "Raebareli" },
            { "district_name": "Rampur" },
            { "district_name": "Saharanpur" },
            { "district_name": "Sambhal" },
            { "district_name": "Sant Kabir Nagar" },
            { "district_name": "Shahjahanpur" },
            { "district_name": "Shamli" },
            { "district_name": "Shravasti" },
            { "district_name": "Siddharthnagar" },
            { "district_name": "Sitapur" },
            { "district_name": "Sonbhadra" },
            { "district_name": "Sultanpur" },
            { "district_name": "Unnao" },
            { "district_name": "Varanasi" }
        ]
    },
    {
        "state_name": "Uttarakhand",
        "districts": [
            { "district_name": "Almora" },
            { "district_name": "Bageshwar" },
            { "district_name": "Chamoli" },
            { "district_name": "Champawat" },
            { "district_name": "Dehradun" },
            { "district_name": "Haridwar" },
            { "district_name": "Nainital" },
            { "district_name": "Pauri Garhwal" },
            { "district_name": "Pithoragarh" },
            { "district_name": "Rudraprayag" },
            { "district_name": "Tehri Garhwal" },
            { "district_name": "Udham Singh Nagar" },
            { "district_name": "Uttarkashi" }
        ]
    },
    {
        "state_name": "West Bengal",
        "districts": [
            { "district_name": "Alipurduar" },
            { "district_name": "Bankura" },
            { "district_name": "Birbhum" },
            { "district_name": "Cooch Behar" },
            { "district_name": "Dakshin Dinajpur" },
            { "district_name": "Darjeeling" },
            { "district_name": "Hooghly" },
            { "district_name": "Howrah" },
            { "district_name": "Jalpaiguri" },
            { "district_name": "Jhargram" },
            { "district_name": "Kalimpong" },
            { "district_name": "Kolkata" },
            { "district_name": "Malda" },
            { "district_name": "Murshidabad" },
            { "district_name": "Nadia" },
            { "district_name": "North 24 Parganas" },
            { "district_name": "Paschim Bardhaman" },
            { "district_name": "Paschim Medinipur" },
            { "district_name": "Purba Bardhaman" },
            { "district_name": "Purba Medinipur" },
            { "district_name": "Purulia" },
            { "district_name": "South 24 Parganas" },
            { "district_name": "Uttar Dinajpur" }
        ]
    },
    {
        "state_name": "Andaman And Nicobar Islands",
        "districts": [
            { "district_name": "Nicobar" },
            { "district_name": "North Middle Andaman" },
            { "district_name": "South Andaman" }
        ]
    },
    {
        "state_name": "Chandigarh",
        "districts": [
            { "district_name": "Chandigarh" }
        ]
    },

    {
        "state_name": "Delhi",
        "districts": [
            { "district_name": "Central Delhi" },
            { "district_name": "East Delhi" },
            { "district_name": "New Delhi" },
            { "district_name": "North Delhi" },
            { "district_name": "North East Delhi" },
            { "district_name": "North West Delhi" },
            { "district_name": "Shahdara" },
            { "district_name": "South Delhi" },
            { "district_name": "South East Delhi" },
            { "district_name": "South West Delhi" },
            { "district_name": "West Delhi" }
        ]
    },
    {
        "state_name": "Jammu And Kashmir",
        "districts": [
            { "district_name": "Anantnag" },
            { "district_name": "Bandipora" },
            { "district_name": "Baramulla" },
            { "district_name": "Budgam" },
            { "district_name": "Doda" },
            { "district_name": "Ganderbal" },
            { "district_name": "Jammu" },
            { "district_name": "Kathua" },
            { "district_name": "Kishtwar" },
            { "district_name": "Kulgam" },
            { "district_name": "Kupwara" },
            { "district_name": "Poonch" },
            { "district_name": "Pulwama" },
            { "district_name": "Rajouri" },
            { "district_name": "Ramban" },
            { "district_name": "Reasi" },
            { "district_name": "Samba" },
            { "district_name": "Shopian" },
            { "district_name": "Srinagar" },
            { "district_name": "Udhampur" }
        ]
    },
    {
        "state_name": "Ladakh",
        "districts": [
            { "district_name": "Kargil" },
            { "district_name": "Leh" }
        ]
    },
    {
        "state_name": "Lakshadweep",
        "districts": [
            { "district_name": "Lakshadweep" }
        ]
    },
    {
        "state_name": "Puducherry",
        "districts": [
            { "district_name": "Karaikal" },
            { "district_name": "Mahe" },
            { "district_name": "Puducherry" },
            { "district_name": "Yanam" }
        ]
    }
]
